import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useStripe } from '@stripe/react-stripe-js';
import { connect } from 'react-redux';
import { asyncConfirmPaymentIntent } from 'actions/order';

function SavedPaymentInfo({
  processor,
  processor_data,
  cc_holder_name,
  cc_last4,
  cc_month,
  cc_year,
  pendingStripeAction,
  confirmPayment
}) {
  const data = processor !== 'testmode' && JSON.parse(processor_data);
  const stripe = useStripe();

  useEffect(() => {
    // Stripe.js not loaded yet or no pendingStripe action
    if (!pendingStripeAction || !stripe) {
      return;
    }
    // show confirm payment popup (3DS)
    stripe.handleCardAction(pendingStripeAction.client_secret).then(() => {
      const secret = pendingStripeAction.client_secret;
      const paymentIntentId = secret.substring(0, secret.indexOf('_secret'));
      const invoiceId = pendingStripeAction.purchase_id;
      confirmPayment(paymentIntentId, invoiceId);
    });
  }, [pendingStripeAction, stripe, confirmPayment]);

  return (
    <div>
      <h4>Saved payment information</h4>
      <span>
        {processor === 'paypalmarketplace' && 'Paypal:'}
        {processor === 'stripe' && 'Credit card:'}
      </span>
      <div className="alert alert-info">
        {processor === 'paypalmarketplace' && <b>{data.buyer_paypal_email}</b>}
        {processor === 'stripe' && (
          <>
            <span>Name: </span>
            <b>{cc_holder_name}</b>
            <br />
            <span>Card number: </span>
            <b>XXXX XXXX XXXX {cc_last4}</b>
            <br />
            <span>Valid Thru: </span>
            <b>
              {cc_month.toString().padStart(2, 0)}/{cc_year}
            </b>
          </>
        )}
      </div>
    </div>
  );
}

SavedPaymentInfo.propTypes = {
  processor: PropTypes.string
};

const mapStateToProps = state => ({
  pendingStripeAction: state.order.pendingStripeAction
});

const mapDispatchToProps = dispatch => ({
  confirmPayment: (paymentIntentId, invoiceId) => dispatch(asyncConfirmPaymentIntent(paymentIntentId, invoiceId))
});

export default connect(mapStateToProps, mapDispatchToProps)(SavedPaymentInfo);
